import { CountryInfoWithCurrency } from '@shared/types/country-info';
import { CurrencyType } from '@shared/types/offers';
import clsx from 'clsx';
import { FC } from 'react';
import { useTranslation as useTranslationHook } from 'react-i18next';
import { icons } from '../../../constants/assets';

type MobileCurrencySwitcherProps = {
  selectedCurrency: CurrencyType;
  selectedCountryInfo: CountryInfoWithCurrency;
  onCurrencyChange: (currency: CurrencyType) => void;
};

export const MobileCurrencySwitcher: FC<MobileCurrencySwitcherProps> = ({
  selectedCurrency,
  selectedCountryInfo,
  onCurrencyChange,
}) => {
  const { t } = useTranslationHook();
  return (
    <div className="mb-5 flex items-center justify-center gap-2 bg-[#101221CC] py-4 sm:hidden">
      <div className="flex items-center gap-2">
        <img
          src={icons.powerIcon}
          alt="POWER coin"
          className="size-5"
        />
        <span
          className={clsx(
            'font-poppins mt-0.5 truncate whitespace-nowrap text-[17.5px] font-black uppercase leading-none',
            selectedCurrency === 'POWER' ? 'text-neon_yellow' : 'text-white/60',
          )}
        >
          {t('powerFiatSwitcher.power')}
        </span>
      </div>

      <button
        type="button"
        onClick={() => onCurrencyChange(selectedCurrency === 'POWER' ? 'FIAT' : 'POWER')}
        className="relative inline-flex h-7 w-12 items-center rounded-full border-2 border-white/40 p-1"
        role="switch"
        aria-checked={selectedCurrency === 'FIAT'}
        aria-label="Toggle currency"
      >
        <span className="absolute inset-1 rounded-full" />
        <span
          className={clsx(
            'relative inline-block size-4 rounded-full bg-white transition-transform duration-200 ease-in-out',
            selectedCurrency === 'FIAT' ? 'translate-x-5' : 'translate-x-0',
          )}
        />
      </button>

      <div className="flex items-center gap-2">
        <span
          className={clsx(
            'font-popins mt-0.5 truncate whitespace-nowrap text-[17.5px] font-black uppercase leading-none',
            selectedCurrency === 'FIAT' ? 'text-neon_yellow' : 'text-white/60',
          )}
        >
          {`${selectedCountryInfo.currency}-${selectedCountryInfo.currencySymbol}`}
        </span>
        <span className="text-xl" role="img" aria-label="Country flag">
          <img
            src={selectedCountryInfo.flagSvg}
            alt=""
            className="mb-0.5 rounded-sm object-cover"
          />
        </span>
      </div>
    </div>
  );
};
